import React from "react";
import loader from "./loader";
import InternalPageRenderer from "./page-renderer";
var ProdPageRenderer = function ProdPageRenderer(_ref) {
  var location = _ref.location;
  var pageResources = loader.loadPageSync(location.pathname);
  if (!pageResources) {
    return null;
  }
  return /*#__PURE__*/React.createElement(InternalPageRenderer, Object.assign({
    location: location,
    pageResources: pageResources
  }, pageResources.json));
};
export default ProdPageRenderer;